import { useQuery, UseQueryResult } from 'react-query';
import { StripeConnectAccount } from 'types';
import { client } from 'utils/api-client';

interface IUseStripeConnectAccount {
  // Defaults to enabled. Callers pass false to skip the request — a gym with no Connect
  // account has nothing to return.
  enabled?: boolean;
}

function useStripeConnectAccount({ enabled = true }: IUseStripeConnectAccount = {}): UseQueryResult<{
  data: StripeConnectAccount;
}> {
  return useQuery(['stripeConnectAccount'], () => client.get(`stripe/connect-account/`), { enabled });
}

export default useStripeConnectAccount;
